<template>
	<div class="dt_cn">
		<div class="pre_detail_pc" v-if="!isPhone">
			<div class="pro_banner">
				<img :src="banner" />
			</div>
			<div class="sort_con">
				<div class="good_info flex1">
					<div class="gd_left">
						<swiper class="hn_swiper" :options="swiperOptions">
							<swiper-slide class="hn_slide" v-for="(item, index) in swiperList" :key="index">
								<img :src="item" />
							</swiper-slide>
							<div class="swiper-pagination pagination33" slot="pagination"></div>
						</swiper>
					</div>
					<div class="gd_right">
						<p class="goods_name">{{ goodsDetail.name }}</p>
						<div class="fwb" v-html="goodsDetail.spec"></div>
						<div class="buy_btn" v-if="goodsDetail.buy_link">
							<div class="btn_bod">
								<span @click="toBuy">商城购买</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="pre_detail_phone" v-if="isPhone">
			<Header2 :meauShow="false" :searchShow="false" pageTitle="产品详情"></Header2>
			<div class="hn_swiper_wrap2">
				<swiper class="hn_swiper" :options="swiperOptions2">
					<swiper-slide class="hn_slide flex2" v-for="(item, index) in swiperList" :key="index">
						<img :src="item" />
					</swiper-slide>
					<div class="swiper-pagination pagination44" slot="pagination"></div>
				</swiper>
				<div class="swp_tit">{{ goodsDetail.name }}</div>
			</div>
			<div class="intro_phone">
				<p class="ip_p1">品牌介绍</p>
				<div class="ip_d1" v-html="goodsDetail.spec"></div>
			</div>
			<div class="tm_jd flex1">
				<div class="tm_jd_item flex2" @click="toTianMao">
					<img src="@/images/productCenter/tm.png" />
					<span>天猫官方旗舰店</span>
				</div>
				<div class="tm_jd_item flex2" @click="toJingDong">
					<img src="@/images/productCenter/jd.png" />
					<span>京东官方旗舰店</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			gid: "",
			staticImg: this.$staticImg + "/",
			swiperList: [],
			goodsDetail: {},
			banner: '',
			swiperOptions: {
				// 分页器配置
				pagination: {
					el: ".pagination33",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			swiperOptions2: {
				// 分页器配置
				pagination: {
					el: ".pagination44",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			isPhone: this.$isMobile,
		};
	},
	created() {
		this.gid = this.$route.query.gid;
		this.banner = this.$route.query.banner;
		this.productdt();
	},
	methods: {
		// 系列下的产品列表
		async productdt() {
			const res = await this.$api.productdt({
				id: this.gid,
			});
			if (res.code == 1) {
				this.goodsDetail = res.data;
				var swarr = this.goodsDetail.banners.split(",");
				for (let i = 0; i < swarr.length; i++) {
					this.swiperList.push(this.staticImg + swarr[i]);
				}
			}
		},
		toBuy() {
			window.open(this.goodsDetail.buy_link, "_blank");
		},
		toTianMao() {
			window.open(this.goodsDetail.buy_link, "_blank");
		},
		toJingDong() {
			window.open('https://mall.jd.com/index-55944.html', "_blank");
		}
	},
}
</script>

<style lang="scss">
.dt_cn {
	@font-face {
		font-family: "SourceHanSans";
		src: url("../../font/SourceHanSansCN-Regular.otf");
	}
	font-family: "SourceHanSans";
	.ho_act1 {
		color: #d43235 !important;
		font-size: 20px !important;
	}
	.pagination33 {
		bottom: 0 !important;
	}
	.pagination33 .swiper-pagination-bullet {
		width: 80px !important;
		height: 2px !important;
		border-radius: 0;
	}
	.pagination44 {
		justify-content: center !important;
	}
	.pagination44 .swiper-pagination-bullet {
		width: 30px !important;
		height: 2px !important;
		border-radius: 0;
	}
	.pre_detail_pc {
		padding-top: 76px;
		padding-bottom: 40px;
		.pro_banner {
			img {
				width: 100%;
			}
		}
		.sort_con {
			width: 100%;
			padding: 50px 0 100px;
			min-height: 300px;
			background-image: url("../../images/bgimg3.png");
			.good_info {
				max-width: 1200px;
				min-width: 950px;
				margin: 0 auto;
				flex-wrap: wrap;
				align-items: flex-start;
				.gd_left {
					width: 40%;
					position: relative;
					padding: 0 20px;
					background-color: #fff;
					.hn_swiper {
						width: 100%;
						height: 653px;
						.hn_slide {
							width: 100%;
							height: 653px;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;

							img {
								height: 653px;
								max-width: 662px;
								width: auto;
							}
						}
						.swiper-pagination-fraction,
						.swiper-pagination-custom,
						.swiper-pagination-bullet-active {
							opacity: 1;
							background: #d43235 !important;
						}
					}
				}
				.gd_right {
					padding-left: 40px;
					padding-right: 20px;
					flex: 1;
					.goods_name {
						color: #333;
						font-size: 48px;
						line-height: 1.2;
						margin-bottom: 36px;
						text-align: left;
					}
					.fwb {
						text-align: justify;
						color: #333;
						font-size: 16px;
						line-height: 1.7;
						margin-bottom: 42px;
						img {
							max-width: 100% !important;
						}
					}
					.buy_btn {
						margin-top: 60px;
						text-align: left;
						.btn_bod {
							padding: 3px;
							border: 1px solid #e94953;
							display: inline-block;
							span {
								width: 162px;
								height: 52px;
								line-height: 52px;
								text-align: center;
								display: block;
								background-color: #d43235;
								color: #fff;
								font-size: 16px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	.pre_detail_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 1.23rem 0 3rem 0;
		.hn_swiper_wrap2 {
			overflow: hidden;
			background-color: #fff;
			padding: 0.65rem 0.5rem 0 0.5rem;
			position: relative;
			.hn_swiper {
				.hn_slide {
					padding-bottom: 1rem;

					img {
						width: 100%;
						margin-right: 0.4rem;
					}
				}
				.swiper-pagination-fraction,
				.swiper-pagination-custom,
				.swiper-pagination-bullet-active {
					opacity: 1;
					background: #d43235 !important;
				}
			}
			.swp_tit {
				text-align: center;
				background-color: #fff;
				color: #555;
				font-size: 18px;
				padding: 0.2rem 0.5rem 0.5rem;
			}
		}
		.intro_phone {
			margin-top: 0.3rem;
			padding: 0.427rem 0.533rem;
			background-color: #fff;
			margin-bottom: 0.267rem;
			.ip_p1 {
				color: #333;
				font-size: 17px;
				font-weight: 700;
				text-align: center;
				margin-bottom: 0.267rem;
			}
			.ip_d1 {
				color: #333;
				font-size: 17px;
				line-height: 1.8;
				text-align: justify;
			}
		}
		.tm_jd {
			position: fixed;
			bottom: 0;
			z-index: 1000;
			width: 100%;
			.tm_jd_item {
				width: 50%;
				background-color: #d50000;
				vertical-align: middle;
				color: #fff;
				text-align: center;
				padding: 10px 15px;
				&:nth-child(2) {
					border-left: 1px solid #fff;
				}
				img {
					height: 30px;
					margin-right: 5px;
				}
				span {
					font-size: 12px;
				}
			}
		}
	}
}
</style>